var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list" },
    [
      _vm._l(_vm.formatVideos, function (video, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "item cursor-pointer",
            on: {
              click: function ($event) {
                _vm.selectedVideo = video
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "cover overflow-hidden relative",
                class: { withPicture: video.cover },
              },
              [
                video.cover
                  ? _c("div", [
                      _c("img", {
                        staticClass: "absolute inset-0 m-auto",
                        attrs: { src: video.cover, alt: "" },
                      }),
                    ])
                  : _c(
                      "div",
                      [
                        _c("Video", {
                          key: index,
                          staticClass: "pointer-events-none",
                          attrs: {
                            url: video.video_url,
                            nocontrols: true,
                            autoplay: false,
                            automuted: true,
                            quality: 240,
                            type: "realtime",
                          },
                        }),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.hideDetails
                  ? _c("i", {
                      staticClass: "cover-icon-play fa-regular fa-circle-play",
                    })
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            !_vm.hideDetails
              ? _c("div", { staticClass: "video-info" }, [
                  video.date
                    ? _c("div", { staticClass: "date" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(video.date) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  video.title
                    ? _c("div", { staticClass: "title" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(video.title) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  video.cta_label
                    ? _c("div", { staticClass: "cta-label" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(video.cta_label) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        )
      }),
      _vm._v(" "),
      _vm.selectedVideo
        ? _c(
            "div",
            {
              staticClass:
                "modal z-40 top-0 left-0 fixed w-full h-full flex items-center justify-center",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "modal-content relative w-full xl:w-7/12 md:w-10/12 mx-auto z-50 md:px-0 px-4",
                },
                [
                  _c("div", { staticClass: "flex w-full justify-end" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close mb-4",
                        on: {
                          click: function ($event) {
                            _vm.selectedVideo = null
                          },
                        },
                      },
                      [_vm._v("\n                    ✖\n                ")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-full mx-auto video-container" },
                    [
                      _c("Video", {
                        key: _vm.selectedVideo.video_url,
                        staticClass: "mb-6",
                        attrs: {
                          url: _vm.selectedVideo.video_url,
                          nocontrols: true,
                          autoplay: false,
                          automuted: false,
                          fullscreenable: true,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }